import * as React from "react";
const SvgBooked = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.111 3.18A7 7 0 0 1 9 2a7.02 7.02 0 0 1 7 7A7 7 0 1 1 5.111 3.18m7.69 3.03c.21.212.21.554 0 .766L7.86 11.948 5.199 9.27a.543.543 0 0 1 0-.765.535.535 0 0 1 .76 0l1.9 1.913 4.182-4.207a.535.535 0 0 1 .76 0",
    clipRule: "evenodd"
  }
));
export default SvgBooked;
